/* SOFIA LINDH Black Friday – fælles nedtælling.
   Brug: <sl-countdown data-end="2026-11-30T23:00:00Z"><span data-d></span><span data-h></span><span data-m></span><span data-s></span></sl-countdown>
   Når tiden er gået, skjules nærmeste [data-bf-campaign]. */
const SL_BF_END = Date.parse('2026-11-30T23:00:00Z');

class SlCountdown extends HTMLElement {
  connectedCallback() {
    this.end = Date.parse(this.dataset.end || '') || SL_BF_END;
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }
  disconnectedCallback() {
    clearInterval(this.timer);
  }
  tick() {
    let ms = this.end - Date.now();
    if (ms <= 0) {
      ms = 0;
      clearInterval(this.timer);
      this.setAttribute('ended', '');
      const campaign = this.closest('[data-bf-campaign]');
      if (campaign && !(window.Shopify && window.Shopify.designMode)) campaign.hidden = true;
    }
    const total = Math.floor(ms / 1000);
    const parts = {
      d: Math.floor(total / 86400),
      h: Math.floor((total % 86400) / 3600),
      m: Math.floor((total % 3600) / 60),
      s: total % 60
    };
    for (const key of Object.keys(parts)) {
      const value = String(parts[key]).padStart(2, '0');
      this.querySelectorAll('[data-' + key + ']').forEach((el) => {
        if (el.textContent !== value) el.textContent = value;
      });
    }
    this.setAttribute('aria-label', parts.d + ' dage, ' + parts.h + ' timer og ' + parts.m + ' minutter tilbage');
  }
}

if (!customElements.get('sl-countdown')) customElements.define('sl-countdown', SlCountdown);
